import { render, staticRenderFns } from "./EmbedVideo.vue?vue&type=template&id=a530e110&"
import script from "./EmbedVideo.vue?vue&type=script&lang=js&"
export * from "./EmbedVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports